// #2753 Quick Order: how any screen opens it. One window event, so a contact card, a company card or the header never imports the whole flow.
// The host (App) listens, lazy-loads the flow and opens it with the customer already in when the caller knows one.
export const QUICK_ORDER_EVENT = 'charlie:quick-order';

// initial = { customer, contact, companyId, contactId } or nothing.
export function openQuickOrder(initial = null) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(QUICK_ORDER_EVENT, { detail: initial || null }));
}
